<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>双十一 魔盒</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="topBar">
      <el-row>
        <el-button type="primary" @click="addNewBox">新增盒子</el-button>
      </el-row>
    </div>
    <div class="list">
      <el-table :data="orderListData" border style="width: 100%">
        <el-table-column prop="id" label="id" width="80"> </el-table-column>
        <el-table-column prop="boxName" label="盒子名称" width="150"> </el-table-column>
        <el-table-column prop="boxType" label="盒子类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.boxType == 'COIN'">代币</span>
            <span v-if="scope.row.boxType == 'MATERIAL_OBJECT'">实物</span>
            <span v-if="scope.row.boxType == 'COIN_MATERIAL_OBJECT'">代币和实物</span>
          </template>
        </el-table-column>



        <el-table-column prop="lotteryLevel" label="盒子奖项级别" width="120"> </el-table-column>
        <el-table-column prop="total" label="盒子总数" width="100"> </el-table-column>
        <el-table-column prop="wij" label="权重系数max" width="120"> </el-table-column>
         <el-table-column prop="warnNum" label="告警数量" width="100"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handlePrizeDetail(scope.row)" type="text" size="small">查看并修改</el-button>
            <el-button @click="handleDelThis(scope.row.id)" type="text" size="small">置为无效</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="新增/修改  盒子" class="boxDialog" @close="closeDialog" :visible.sync="BoxFormDialogVisible">
      <el-form :model="boxInfo">
        <div class="dialogContet">
          <div class="leftContent">
            <el-form-item label="盒子名称" class="setWidthS" :label-width="formLabelWidth">
              <el-input v-model="boxInfo.boxName" placeholder="盒子名称" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="盒子类型" :label-width="formLabelWidth">
              <el-select v-model="boxInfo.boxType" placeholder="请选择盒子类型">
                <el-option label="代币" value="COIN"></el-option>
                <el-option label="实物" value="MATERIAL_OBJECT"></el-option>
                <el-option label="代币和实物" value="COIN_MATERIAL_OBJECT"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否激活" :label-width="formLabelWidth">
              <el-switch
                style="display: block;margin:8px 0 0 30px"
                v-model="boxInfo.activated"
                active-text="激活"
                inactive-text="暂不激活"
              >
              </el-switch>

              <!-- <el-select v-model="boxInfo.activated" placeholder="请选择是否激活">
                <el-option label="激活" value=true></el-option>
                <el-option label="不激活" value=false></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="总价值" class="setWidthS" :label-width="formLabelWidth">
              <el-input v-model.number="boxInfo.amountForUsdt" placeholder="概总价值--换算usdt(必须) ,"></el-input>
            </el-form-item>
            <el-form-item label="盒子奖项级别" class="setWidthS" :label-width="formLabelWidth">
              <el-input v-model.number="boxInfo.lotteryLevel" placeholder="手填： 1 2 3 4 5 6 7 8"></el-input>
            </el-form-item>
            <el-form-item label="盒子总数量" class="setWidthS" :label-width="formLabelWidth">
              <el-input v-model.number="boxInfo.total" placeholder="盒子总数量(必须)"></el-input>
            </el-form-item>
            <el-form-item label="权重系数max" class="setWidthS" :label-width="formLabelWidth">
              <el-input v-model.number="boxInfo.wij" placeholder="权重系数(必须)"></el-input>
            </el-form-item>
            <el-form-item label="告警数量" class="setWidthS" :label-width="formLabelWidth">
              <el-input v-model.number="boxInfo.warnNum" placeholder="告警数量(必须)"></el-input>
            </el-form-item>
          </div>
          <div class="rightContent">
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-button type="primary" @click="addPrizeItemToBox">添加奖品</el-button>
              <el-collapse-item
                :title="'奖项' + (index + 1)"
                v-for="(prizeOne, index) in boxInfo.prizeList"
                :key="index"
                :name="'奖项' + (index + 1)"
              >
                <el-form-item label="奖项名称" class="setWidthF" :label-width="formLabelWidth">
                  <el-input v-model="prizeOne.name" placeholder="奖项名称"></el-input>
                </el-form-item>
                <el-form-item label="prizeName" class="setWidthF" :label-width="formLabelWidth">
                  <el-input v-model="prizeOne.prizeName" placeholder="实物时为实物名称，代币时为币种类型(必须)"></el-input>
                </el-form-item>
                <el-form-item label="代币币种小数位数" class="setWidthF" label-width="130px">
                  <el-input v-model.number="prizeOne.precision" placeholder="代币币种小数位数"></el-input>
                </el-form-item>
                <el-form-item label="奖品数量" class="setWidthF" :label-width="formLabelWidth">
                  <el-input v-model.number="prizeOne.prizeNumber" placeholder="奖品类型为实物时，实物的数量(非必须)"></el-input>
                </el-form-item>
                <el-form-item label="奖项类型" :label-width="formLabelWidth">
                  <el-select v-model="prizeOne.prizeType" placeholder="请选择奖项类型">
                    <el-option label="代币" value="COIN"></el-option>
                    <el-option label="实物" value="MATERIAL_OBJECT"></el-option>
                    <el-option label="代币和实物" value="COIN_MATERIAL_OBJECT"></el-option>
                      <el-option label="加息券" value="COUPON"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="最大中奖概率" class="setWidthF" :label-width="formLabelWidth">
                  <el-input v-model.number="prizeOne.proportionMax" placeholder="最大中奖概率(必须)"></el-input>
                </el-form-item>
                <el-form-item label="最小中奖概率" class="setWidthF" :label-width="formLabelWidth">
                  <el-input v-model.number="prizeOne.proportionMin" placeholder="最小中奖概率(必须)"></el-input>
                </el-form-item>
                <el-form-item label="" class="setWidthF" :label-width="formLabelWidth">
                  <el-button type="warning" class="delThisPrize" @click="delThisPrize(index)" plain>删除当前奖项</el-button>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>

        <!-- {{ boxInfo }} -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="BoxFormDialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="btnAction == 'update'" @click="updateBoxBtn()">确 定 修 改</el-button>
        <el-button type="primary" v-else @click="addBoxBtn()">确 定 添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
// import UserList from './components/list';
import { mapState, mapActions, mapMutations } from "vuex";
import api from "./api";

export default {
  name: "doubleEleven",
  components: {
    //  UserList
  },
  data() {
    return {
      btnAction: "",
      activeNames: [],
      tableData: [],
      BoxFormDialogVisible: false,
      boxInfo: {
        boxName: "", //盒子名称
        boxType: "", //类型
        activated: "true", //是否激活
        amountForUsdt: NaN, //大概总价值--换算usdt(必须) ,
        lotteryLevel: "", //12345盒子奖项级别--暂时用于后台大奖控制(必须) ,
        total: "", //盒子总数量(必须) ,
        wij: "", // 权重系数(必须) ,
        warnNum: "", //告警数量
        prizeList: [
          {
            name: "", //奖项名称
            precision: "", //代币币种小数位数
            prizeName: "", //实物时为实物名称，代币时为币种类型(必须) ,
            prizeNumber: "", //奖品数量--奖品类型为实物时，实物的数量(非bixu)
            prizeType: "", //奖项类型--COIN:代币;MATERIAL_OBJECT:实物(必须
            proportionMax: "", //最大中奖概率(必须) ,
            proportionMin: "" // 最小中奖概率(必须)
          }
        ]
      },

      featureBoxInfo: null, //正在操作的boxInfo

      formLabelWidth: "120px"
    };
  },
  computed: {
    ...mapState("magicBox", ["orderListData"])
  },
  methods: {
    ...mapActions("magicBox", ["getBoxListA"]),
    // getBoxListA() {
    //   this.getBoxList();
    // }

    handleChange(val) {
      console.log(val);
    },

    //删除
    handleDelThis(id) {
      let that = this;
      api.deleteBox(id).then(res => {
        console.log("删除", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.BoxFormDialogVisible = false;
          that.getBoxListA();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    //查看盒子详情
    handlePrizeDetail(row) {
      this.btnAction = "update";
      this.BoxFormDialogVisible = true;
      this.featureBoxInfo = JSON.parse(JSON.stringify(row)); //深拷贝
      this.boxInfo = this.featureBoxInfo;
    },
    //添加盒子
    addNewBox() {
      this.BoxFormDialogVisible = true;
      this.btnAction = "add";
      this.boxInfo = {
        boxName: "", //盒子名称
        boxType: "", //类型
        activated: true, //是否激活
        amountForUsdt: "", //大概总价值--换算usdt(必须) ,
        lotteryLevel: "", //12345盒子奖项级别--暂时用于后台大奖控制(必须) ,
        total: "", //盒子总数量(必须) ,
        wijMax: "", // 权重系数max(必须) ,
        wijMin: "", //权重系数min
        prizeList: [
          {
            name: "", //奖项名称
            precision: "", //代币币种小数位数
            prizeName: "", //实物时为实物名称，代币时为币种类型(必须) ,
            prizeNumber: "", //奖品数量--奖品类型为实物时，实物的数量(非bixu)
            prizeType: "", //奖项类型--COIN:代币;MATERIAL_OBJECT:实物(必须
            proportionMax: "", //最大中奖概率(必须) ,
            proportionMin: "" // 最小中奖概率(必须)
          }
        ]
      };
      this.activeNames[0] = "奖项1";
    },
    //添加盒子里面的奖项
    addPrizeItemToBox() {
      this.boxInfo.prizeList.push({
        name: "", //奖项名称
        precision: "", //代币币种小数位数
        prizeName: "", //实物时为实物名称，代币时为币种类型(必须) ,
        prizeNumber: "", //奖品数量--奖品类型为实物时，实物的数量(非bixu)
        prizeType: "", //奖项类型--COIN:代币;MATERIAL_OBJECT:实物(必须
        proportionMax: "", //最大中奖概率(必须) ,
        proportionMin: "" // 最小中奖概率(必须)
      });
    },

    //删除当前行
    delThisPrize(index) {
      this.boxInfo.prizeList.splice(index, 1);
    },

    //关闭的回调
    closeDialog() {
      this.activeNames = [];
      this.boxInfo = {};
      this.btnAction = "";
    },

    //确定添加盒子
    addBoxBtn() {
      let that = this;
      api.createBox(this.boxInfo).then(res => {
        console.log("确定添加盒子", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.BoxFormDialogVisible = false;
          that.getBoxListA();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },

    //修改盒子
    updateBoxBtn() {
      let that = this;
      api.updateBox(this.boxInfo).then(res => {
        console.log("修改盒子", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.BoxFormDialogVisible = false;
          that.getBoxListA();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getBoxListA();
  }
};
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
  .topBar {
    width: 100%;
    padding: 30px;
  }
  .list {
    width: 100%;
  }
  .boxDialog {
    .dialogContet {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .leftContent {
        width: 40%;
      }
      .rightContent {
        width: 58%;
        padding-left: 20px;
        border: 1px dashed #868181;
        .delThisPrize {
          text-align: right;
          float: right;
        }
      }
    }

    .setWidthS {
      width: 336px;
    }
    .setWidthF {
      width: 500px;
    }
  }
}
</style>
